import React from "react";
import { connect } from "react-redux";
import qs from "qs";
import classNames from "classnames";
import T from "i18n-react";
import {
	getPublicationShareData,
	getPublicationForm,
} from "../actions/CompanyPublicationShareActions";
import FormRender from "./forms/FormRender";
import FileUpload from "../components/FileUpload";
import PropTypes from "prop-types";
import request from "superagent";
import config from "../config";
import { Modal, ModalBody } from "reactstrap";
import update from "immutability-helper";
import Notifications from "react-notification-system-redux";
import moment from "moment";
import { CSSTransitionGroup } from "react-transition-group";
import { API_BASE } from "../config";
import SetLanguage from "../components/SetLanguage";
import { changeLanguage } from "../actions/root";

function ARGBTextColorFilter(color) {
	var R = ((color & 0x00ff0000) >> 16) / 255;
	var B = ((color & 0x0000ff00) >> 8) / 255;
	var G = (color & 0x000000ff) / 255;

	var L = 0.299 * R + 0.587 * G + 0.114 * B;

	if (L >= 0.5) {
		return "#000000";
	}

	return "#ffffff";
}

export const Hex2ARGBFilter = (color) => {
	if (7 !== color.length) {
		return 0;
	}

	return parseInt("FF" + color.substr(1), 16);
};

const mapStateToProps = ({ Share: { data, form } }) => ({
	data,
	form,
});

const mapDispatchToProps = (dispatch, props) => ({
	dispatch,
	getPublicationShareData: (params) =>
		dispatch(getPublicationShareData(props.match.params.shareId, params)),
	getPublicationForm: (formId) => dispatch(getPublicationForm(formId)),
	changeLanguage: (formId) => dispatch(changeLanguage(formId))
});
export class DokivShareForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			toggleHeader: undefined,
			imageFetched: false,
		};
		this.approveData = this.approveData.bind(this);
		this.afterSubmit = this.afterSubmit.bind(this);
		this.googleTranslateElementInit = this.googleTranslateElementInit.bind(
			this
		);
		this.toggleRef = React.createRef();
	}

	googleTranslateElementInit() {
		new window.google.translate.TranslateElement(
			{ pageLanguage: "en", multilanguagePage: true },
			"google_translate_element"
		);
	}

	getChildContext() {
		return {
			translate: { translate: (s) => T.translate("form." + s) },
			fileUpload: FileUpload,
			formId: this.props.form.id ? this.props.form.id : "",
		};
	}

	approveData() {
		request
			.post(
				config.SHARE_API_BASE +
				"/" +
				this.state.data.Share.ID +
				"/approve"
			)
			.end((err, resp) => {
				if (!err) {
					this.setState({
						data: update(this.state.data, {
							Approved: { $set: "true" },
							Share: {
								ApprovedByIp: { $set: resp.id },
							},
							ApprovedAt: { $set: new Date() },
						}),
					});
				} else {
					this.props.dispatch(
						Notifications.error({
							title: "",
							message: "The share could not be approved",
							position: "tc",
							autoDismiss: 5,
						})
					);
				}
			});
	}

	componentDidMount() {
		const query = qs.parse(this.props.location.search, {
			ignoreQueryPrefix: true,
		});
		this.props.getPublicationShareData(query);
        
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.data !== this.props.data) {
			this.setState({
				data: nextProps.data,
			});

			const query = qs.parse(nextProps.location.search, {
				ignoreQueryPrefix: true,
			});
			if (nextProps.data.Files && nextProps.data.Files.length > 0) {
				this.setState({
					rawFile:
						config.SHARE_API_BASE +
						"/" +
						nextProps.data.Share.ID +
						"/file?token=" +
						query.token +
						"&fileId=" +
						nextProps.data.Files[0].FileID,
				});
			}

			if (nextProps.data.Publication.features.currentFormId) {
				this.props.getPublicationForm(
					nextProps.data.Publication.features.currentFormId
				);
			}

			request
				.get(
					config.API_BASE +
					"/files/" +
					nextProps.data.Publication.companyId +
					"_pub_" +
					nextProps.data.Publication.type.toLowerCase()
				)
				.end((err, resp) => {
					if (resp.status === 200) {
						this.setState({
							urlBaseImage:
								config.API_BASE +
								"/files/" +
								nextProps.data.Publication.companyId +
								"_pub_" +
								nextProps.data.Publication.type.toLowerCase(),
						});
					}
					this.setState({
						imageFetched: true,
					});
				});
		}

		if (this.props.form !== nextProps.form) {
			if (nextProps.form && nextProps.form.googleTranslate) {
				window.googleTranslateElementInit = this.googleTranslateElementInit;
				let googleTranslateScript = document.createElement("script");
				googleTranslateScript.type = "text/javascript";
				googleTranslateScript.async = true;
				googleTranslateScript.src =
					"//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
				(
					document.getElementsByTagName("head")[0] ||
					document.getElementsByTagName("body")[0]
				).appendChild(googleTranslateScript);
			}
		}
	}

	downloadPdf = (formData) => {
		let elForm = document.createElement("form");

		let elName = document.createElement("input");
		let elDownload = document.createElement("input");

		elForm.setAttribute("method", "GET");
		elForm.setAttribute(
			"action",
			API_BASE +
			`/files/${formData.id}?download=true&fileName=${formData.id}.pdf`
		);
		elDownload.setAttribute("type", "hidden");
		elDownload.setAttribute("name", "download");
		elDownload.setAttribute("value", true);

		elName.setAttribute("type", "hidden");
		elName.setAttribute("name", "fileName");
		elName.setAttribute("value", formData.id);
        elName.setAttribute(
			"value",
			this.props.data.Publication.objectNumber +
				"-" +
				formData.humanReadableId.trim() +
				".pdf"
		);

		elForm.appendChild(elName);
		elForm.appendChild(elDownload);
		document.body.append(elForm);
		elForm.submit();
	};

	afterSubmit(resp) {
		setTimeout(() => {
			this.setState({
				formSubmitted:
					this.props.form.thankMessage.length > 0
						? this.state.data.Publication.objectNumber +
						"-" +
						resp.humanReadableId
						: false,
			});
		});

		let existed = this.props.form.webHooks.some((wh) => {
			return wh.indexOf("save-a-copy-form") > -1;
		});
		if (existed) {
			setTimeout(() => {
				this.props.dispatch(
					Notifications.success({
						title: "",
						message: T.translate(
							"form.download-a-copy-notification"
						),
						position: "tc",
						autoDismiss: 3,
					})
				);
			}, 1000);

			setTimeout(() => {
				this.downloadPdf(resp);
			}, 10000);
		}
	}

	render() {
		let { form } = this.props;
		let {
			data,
			toggleHeader,
			urlBaseImage,
			imageFetched,
			rawFile,
			formSubmitted,
		} = this.state;
		let onlyContent = "false";
		let bgcolor = "#f5f5f5";
		const query = qs.parse(this.props.location.search, {
			ignoreQueryPrefix: true,
		});
		onlyContent = query.onlyContent;
		if (query.bgcolor) {
			bgcolor = "#" + query.bgcolor;
		}

		return (
			<div>
				{data ? (
					<div>
						{onlyContent === "false" ||
							onlyContent === undefined ? (
							<header
								className={classNames("share-header", {
									"share-header__hide":
										urlBaseImage || !imageFetched,
								})}
							>
								<div
									className="share-header__bar main cf"
									style={
										data.extras &&
											data.extras.portalColors &&
											data.extras.portalColors.headerBanner
											? {
												backgroundColor:
													data.extras.portalColors
														.headerBanner,
											}
											: {}
									}
								>
									<a
										href="https://dokiv.com/"
										className="share-header__logo"
									>
										{data.Logo.length ? (
											<img
												alt=""
												src={`data:${data.Logo}`}
											/>
										) : (
											<img
												alt=""
												src="images/logos/logo-horizontal-rbg-white.png"
											/>
										)}
									</a>
								</div>
							</header>
						) : null}

						<main
							className={classNames({
								"share__wrapper-page":
									onlyContent === "false" ||
									onlyContent === undefined,
							})}
							style={{
								background:
									urlBaseImage &&
										(onlyContent === "false" ||
											onlyContent === undefined)
										? "url(" + urlBaseImage + ") no-repeat"
										: "none",
								backgroundColor: bgcolor,
							}}
						>
							<div className="content-holder">
								{urlBaseImage &&
									(onlyContent === "false" ||
										onlyContent === undefined) ? (
									<div className={classNames("share-header__more-info", {

										"sidebar-enter": toggleHeader,
										"sidebar-leave": toggleHeader === false,
										"sidebar-hide": !toggleHeader,
									})}>
										<div style={
											data.extras &&
												data.extras.portalColors &&
												data.extras.portalColors
													.headerBanner
												? {
													background:
														data.extras
															.portalColors
															.headerBanner,
													color: ARGBTextColorFilter(
														Hex2ARGBFilter(
															data
																.extras
																.portalColors
																.headerBanner
														)
													),
												}
												: {}
										} className="share-header share-header__bar cf">
											<a
												href="https://dokiv.com/"
												className="share-header__logo more-info"
											>
												{data.Logo
													.length ? (
													<img
														alt=""
														src={`data:${data.Logo}`}
													/>
												) : (
													<img
														alt=""
														src={process.env.PUBLIC_URL + "/images/logos/logo-horizontal-rbg-white.png"}
													/>
												)}
											</a>
											<div className="share-header__information main">
												<p>
													Enddate:{" "}
													{moment(
														data.Share
															.Deadline
													).format(
														"YYYY-MM-DD"
													)}
												</p>
											</div>
										</div>
										<div className="share-header__button-more-info">
											<button
												type="button"
												onClick={() => {
													this.setState({
														toggleHeader: !toggleHeader,
													});
												}}
												style={
													data.extras &&
														data.extras
															.portalColors &&
														data.extras
															.portalColors
															.headerMenuButton
														? {
															background:
																data
																	.extras
																	.portalColors
																	.headerMenuButton,
															borderColor:
																data
																	.extras
																	.portalColors
																	.headerMenuButton,
															color: ARGBTextColorFilter(
																Hex2ARGBFilter(
																	data
																		.extras
																		.portalColors
																		.headerMenuButton
																)
															),
														}
														: {}
												}
												className={classNames(
													"button",
													"icon-right"
												)}
											>
												More info
												<i
													className={
														classNames("fa", {
															"fa-chevron-up": toggleHeader,
															"fa-chevron-down": !toggleHeader
														})
													}
												/>
											</button>
										</div>
									</div>

								) : null}
							</div>

							<div className="content-holder">
								{data.Approved === "true" ? (
									<div className="row alert-bar__wrap alert-bar--positive">
										<i className="fa fa-check-circle" />

										<div className="alert-bar__body">
											<strong>Confirmed!</strong>
											<span>
												Confirmed from IP :{" "}
												{data.Share.ApprovedByIp}
											</span>
											<span>
												Confirmed at:{" "}
												{moment(data.ApprovedAt).format(
													"YYYY-MM-DD HH:MM"
												)}
											</span>
										</div>
									</div>
								) : null}

								<div className="share__google--translate row--small cf">
									<div
										className="line-component--omega text-right"
										id="google_translate_element"
									/>
								</div>

								<section>
									<div
										className={
											"button__bar button__bar--back cf"
										}
									>
										{formSubmitted ? (
											<button
												onClick={() => {
													this.setState({
														formSubmitted: null,
													});
												}}
												className="button"
												type="button"
											>
												{T.translate(
													"submit-form-again"
												)}
											</button>
										) : null}
										{!formSubmitted && !onlyContent && !urlBaseImage && imageFetched && data.Share
											.Deadline && 
										<div className="share-header__information cf">
											<div className="line-component--omega">
												<p style={{'top': 5}}>
													Enddate:{" "}
													{moment(
														data.Share
															.Deadline
													).format(
														"YYYY-MM-DD"
													)}
												</p>
											</div>
										</div>}

									</div>
									<div
										id="form-wrap"
										className={classNames(
											"form-wrap share__body",
											{
												"form-step":
													data.Publication.features
														.layoutFormType ===
													"step",
											}
										)}
									>
										<div>
											{!formSubmitted ? (
												<header
													className={classNames(
														"share__heading"
													)}
												>
													<h1>
														{data.Publication.name}
													</h1>
													<p
														className="print-hide"
														style={{
															marginTop: "5px",
														}}
													>
														<a
															onClick={() => {
																window.print();
															}}
														>
															<i className="fa fa-print" />
															{T.translate(
																"print"
															)}
														</a>
													</p>
												</header>
											) : null}

											{!formSubmitted ? (
												<div
													className="row--large"
													dangerouslySetInnerHTML={{
														__html:
															data.Publication
																.description,
													}}
												/>
											) : null}

											{formSubmitted ? (
												<div
													className={classNames(
														"row"
													)}
												>
													<div
														className="row--large share__thank-msg"
														dangerouslySetInnerHTML={{
															__html:
																form.thankMessage,
														}}
													/>

													<strong className="row--large">
														<p className="text-center cf">
															{T.translate(
																"form.submission-id"
															)}
															{": "}{" "}
															{formSubmitted}
														</p>
													</strong>
												</div>
											) : null}

											{!formSubmitted &&
												data.Files &&
												data.Files.length &&
												(data.Files[0].FileType ===
													"video" ||
													data.Files[0].FileType ===
													"image") && data.Publication.description.search(
														data.Files[0]
													) === -1 ? (
												<div
													className={classNames(
														"row cf"
													)}
												>
													<div className="publication-details__form-media">
														<a>
															<div className="versions__holder">
																{data.Files[0]
																	.FileType ===
																	"image" ? (
																	<img
																		src={
																			rawFile
																		}
																		alt={
																			data
																				.Files[0]
																				.OriginalFilename
																		}
																	/>
																) : null}

																{data.Files[0]
																	.FileType ===
																	"video" ? (
																	<video
																		controls
																		id="share-video"
																		preload="false"
																		width="100%"
																	>
																		<source
																			src={
																				rawFile
																			}
																		/>
																	</video>
																) : null}
															</div>
														</a>
													</div>
												</div>
											) : null}

											{form.active && !formSubmitted ? (
												<FormRender
													companyId={
														this.props.data
															.CompanyId
													}
													form={form}
													key={form.id}
													layoutFormType={
														data.Publication
															.features
															.layoutFormType
															? data.Publication
																.features
																.layoutFormType
															: null
													}
													publication={
														data.Publication
													}
													formData={data}
													onAfterSubmit={
														this.afterSubmit
													}
												/>
											) : null}
											{!form.active ? (
												<div className="row--large">
													<p>
														{T.translate(
															"form-not-active"
														)}
													</p>
												</div>
											) : null}

											<footer className="share__footer">
												<div>
													<p>
														{"Powered by "}
														<a
															href="https://dokiv.com"
															target={
																onlyContent ===
																	"false" ||
																	onlyContent ===
																	undefined
																	? "_self"
																	: "_blank"
															}
														>
															{"Dokiv"}
														</a>
													</p>
													<p style={{ opacity: 0.6 }}>
														{
															data.Publication
																.objectNumber
														}
													</p>
													
													<div className="share__language">
									                  	<SetLanguage
									                  		 className="share__language"
										                    user={{language: window.localStorage.language}}
										                    afterChange={c => {
										                    	window.localStorage.language = c;
										                    	this.props.changeLanguage(c);
										                    }}
									                  	/>
								                  	</div>
												</div>
											</footer>
										</div>
									</div>
								</section>
							</div>
						</main>

						<Modal
							isOpen={data.Approved === "false"}
							toggle={() => {
								this.setState({
									approveModal: !this.state.approveModal,
								});
							}}
							className="reminder-detail__wrapper"
						>
							<ModalBody className="text-center">
								<div
									className="share__confirm-message"
									dangerouslySetInnerHTML={{
										__html: T.translate("confirm-message"),
									}}
								/>
								<button
									onClick={this.approveData}
									type="button"
									className="button button--positive share__confirm-btn"
								>
									{T.translate("verify")}
								</button>
								<div className="separator" />
							</ModalBody>
						</Modal>
					</div>
				) : null}
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(DokivShareForm);
DokivShareForm.childContextTypes = {
	translate: PropTypes.shape({
		translate: PropTypes.func,
	}),
	fileUpload: PropTypes.func,
	formId: PropTypes.string.isRequired,
};
